'use client';

import { dispatch } from '../../../hooks/use-bus';
import useShowMyAccount from '../../../hooks/use-show-my-account';
import { AppBusEventType } from '../../../interfaces/bus-events';
import OWLink from '../../shared/ow-link';
import SpriteIcon from '../../shared/sprite-icon';
import './header-guest-menu.scss';

// -----------------------------------------------------------------------------
// The logged-out header entry point: a generic user icon that, on hover, opens
// a small dropdown with "Login" and "My Account". Replaces the old plain
// "Login" text button. Once signed in the header swaps this for the profile
// circle (UserSettingsMenu) instead. The open/close is CSS-driven (hover +
// focus-within) so it works without JS state and stays keyboard-accessible.
export const HeaderGuestMenu = (): JSX.Element => {
  const showMyAccount = useShowMyAccount();

  const handleLogin = (): void => {
    dispatch({
      type: AppBusEventType.App.ShowLoginModal,
      data: { show: true, source: 'header' },
    });
  };

  return (
    <div className="header-guest-menu">
      <button
        className="header-guest-menu__trigger"
        aria-label="Account"
        aria-haspopup="menu"
      >
        <SpriteIcon icon="user" />
      </button>

      <div className="header-guest-menu__dropdown" role="menu">
        <ul className="header-guest-menu__menu">
          <li className="menu-item">
            <button type="button" role="menuitem" onClick={handleLogin}>
              Login
            </button>
          </li>
          {showMyAccount && (
            <li className="menu-item">
              <OWLink role="menuitem" href="/my-account">
                My Account
              </OWLink>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default HeaderGuestMenu;
